// =========================
// Swiper類：対象がある時だけ初期化
// =========================

// サムネスライダー & メイン
let thumbSwiper = null;
let mainSwiper = null;

const thumbEl = document.querySelector(".thumb-swiper");
const mainEl = document.querySelector(".main-swiper");

if (thumbEl && typeof Swiper !== 'undefined') {
  thumbSwiper = new Swiper(".thumb-swiper", {
    direction: 'horizontal',
    spaceBetween: 0,
    loop: false,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    freeMode: true,
    navigation: {
      nextEl: '.thumb-next',
      prevEl: '.thumb-prev',
    },
    breakpoints: {
      0: { slidesPerView: 4.7 },
      768: { slidesPerView: 9.5 }
    }
  });
}

if (mainEl && typeof Swiper !== 'undefined') {
  mainSwiper = new Swiper(".main-swiper", {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    thumbs: thumbSwiper ? { swiper: thumbSwiper } : undefined,
  });

  // スマホでサムネイルを左寄せ
  function updateThumbLeft() {
    if (!thumbSwiper || !mainSwiper) return;
    if (window.innerWidth <= 768) {
      thumbSwiper.slideToLoop(mainSwiper.realIndex, 300);
    }
  }
  mainSwiper.on('slideChange', updateThumbLeft);
  window.addEventListener('resize', updateThumbLeft);

}

// バブル hover
document.addEventListener('DOMContentLoaded', function() {
  const bubbles = document.querySelectorAll('.bubble-link');
  bubbles.forEach(function(bubble) {
    const originalBg = bubble.style.backgroundColor;
    const hoverBg = bubble.dataset.bgHover;

    bubble.addEventListener('mouseenter', function() {
      bubble.style.backgroundColor = hoverBg;
    });
    bubble.addEventListener('mouseleave', function() {
      bubble.style.backgroundColor = originalBg;
    });
  });
});

// ピックアップカテゴリースライダー
if (document.querySelector('.pick-swiper') && typeof Swiper !== 'undefined') {
  new Swiper('.pick-swiper', {
    loop: false,
    speed: 600,
    slidesPerView: 'auto',
    spaceBetween: 1,
    autoplay: { delay: 4000, disableOnInteraction: false },
    pagination: { el: '.pick-pagination', clickable: true },
    navigation: { nextEl: '.pick-next', prevEl: '.pick-prev' },
    breakpoints: {
      768: { slidesPerView: 'auto', spaceBetween: 1 },
      1024: { slidesPerView: 'auto', spaceBetween: 1 },
    },
  });
}

// レコメンドスライド
if (document.querySelector('.reco-swiper') && typeof Swiper !== 'undefined') {
  new Swiper('.reco-swiper', {
    loop: false,
    speed: 600,
    slidesPerView: 2,
    spaceBetween: 1,
    autoplay: { delay: 4000, disableOnInteraction: false },
    pagination: { el: '.reco-pagination', clickable: true },
    navigation: { nextEl: '.reco-next', prevEl: '.reco-prev' },
    breakpoints: {
      768: { slidesPerView: 2, spaceBetween: 1 },
      1024: { slidesPerView: 4, spaceBetween: 1 },
    },
  });
}


// =========================
// LOOK BOOK（PC通常 / SPはモーダル）
// =========================
(() => {
  function initLookbook(area) {
    if (!area) return;

    // 多重実行防止
    if (area.dataset.lookbookInited === '1') return;
    area.dataset.lookbookInited = '1';

    let lookIndex = 0;
    let modalIndex = 0;
    let startX = 0;
    let lockScrollY = 0;

    const looks = [...area.querySelectorAll('.look')];
    if (!looks.length) return;

    const nextBtn = area.querySelector('.arrow.next');
    const prevBtn = area.querySelector('.arrow.prev');

    const sectionId = area.id.replace('Lookbook-', '');
    const modal = document.getElementById(`modal-${sectionId}`);

    const baseWidth = 1400;
    const target = area.querySelector('.pc-scale-inner');
    const wrap = area.querySelector('.pc-scale-wrap');

    function updateScale() {
      if (!target || !wrap) return;

      if (window.innerWidth <= 768) {
        target.style.transform = '';
        wrap.style.height = '';
        return;
      }

      const scale = window.innerWidth / baseWidth;
      target.style.transform = `scale(${scale})`;
      wrap.style.height = `${target.offsetHeight * scale}px`;
    }

    function lockBodyScroll() {
      lockScrollY = window.scrollY || window.pageYOffset;
      document.body.classList.add('lookbook-modal-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${lockScrollY}px`;
      document.body.style.left = '0';
      document.body.style.width = '100%';
    }

    function unlockBodyScroll() {
      document.body.classList.remove('lookbook-modal-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.width = '';
      window.scrollTo(0, lockScrollY);
    }

    function showLook(i) {
      if (!looks.length) return;
      lookIndex = (i + looks.length) % looks.length;

      looks.forEach((el, idx) => {
        el.classList.toggle('is-active', idx === lookIndex);
      });
    }

    function showProduct(lookEl, i) {
      const points = [...lookEl.querySelectorAll('.point')];
      const prods  = [...lookEl.querySelectorAll('.product')];
      const dots   = [...lookEl.querySelectorAll('.dots span')];
      const pcBtn  = lookEl.querySelector('.common_btn.sp_none a');

      if (!prods[i] || !points[i] || !dots[i]) return;

      prods.forEach(p => p.classList.remove('is-active'));
      points.forEach(p => p.classList.remove('is-active'));
      dots.forEach(d => d.classList.remove('is-active'));

      prods[i].classList.add('is-active');
      points[i].classList.add('is-active');
      dots[i].classList.add('is-active');

      if (pcBtn) {
        pcBtn.setAttribute('href', prods[i].dataset.url || '#');
      }
    }

    function resetLookProducts(lookEl) {
      const points = [...lookEl.querySelectorAll('.point')];
      const prods  = [...lookEl.querySelectorAll('.product')];
      const dots   = [...lookEl.querySelectorAll('.dots span')];
      const pcBtn  = lookEl.querySelector('.common_btn.sp_none a');

      points.forEach((p, idx) => p.classList.toggle('is-active', idx === 0));
      prods.forEach((p, idx) => p.classList.toggle('is-active', idx === 0));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === 0));

      if (pcBtn && prods[0]) {
        pcBtn.setAttribute('href', prods[0].dataset.url || '#');
      }
    }

    function activateLookByBlockId(blockId) {
      const targetLook = area.querySelector(`.look[data-block-id="${blockId}"]`);
      if (!targetLook) return;

      looks.forEach((lookEl, idx) => {
        const active = lookEl === targetLook;
        lookEl.classList.toggle('is-active', active);
        if (active) lookIndex = idx;
      });

      resetLookProducts(targetLook);
    }

    function openModal(lookEl, i) {
      if (!modal) return;
      modalIndex = i;

      const box   = modal.querySelector('.modal-box');
      const photo = modal.querySelector('.modal-photo');
      const wrap  = modal.querySelector('.modal-products');
      const dots  = modal.querySelector('.modal-dots');
      if (!box || !photo || !wrap || !dots) return;

      const lookImage = lookEl.querySelector('.look-image');
      photo.innerHTML = lookImage ? lookImage.outerHTML : '';
      photo.querySelector('.common_btn')?.remove();

      photo.querySelectorAll('.point').forEach((pt) => {
        pt.addEventListener('click', () => {
          const idx = Number(pt.dataset.i);
          if (Number.isNaN(idx)) return;
          modalIndex = idx;
          updateModal();
        });
      });

      wrap.innerHTML = '<div class="modal-track"></div>';
      dots.innerHTML = '';
      const track = wrap.firstChild;

      const products = [...lookEl.querySelectorAll('.product')];
      products.forEach((p, idx) => {
        const url = p.dataset.url || '#';
        track.insertAdjacentHTML(
          'beforeend',
          `<div class="modal-slide">
            <a class="modal-link" href="${url}">
              <img src="${p.dataset.img || ''}" alt="">
            </a>
            <p>${p.dataset.name || ''}</p>
          </div>`
        );

        const d = document.createElement('span');
        d.addEventListener('click', () => {
          modalIndex = idx;
          updateModal();
        });
        dots.appendChild(d);
      });

      track.ontouchstart = (e) => startX = e.touches[0].clientX;
      track.ontouchend = (e) => {
        const dx = startX - e.changedTouches[0].clientX;
        if (Math.abs(dx) > 40) {
          if (dx > 0 && modalIndex < track.children.length - 1) modalIndex++;
          if (dx < 0 && modalIndex > 0) modalIndex--;
          updateModal();
        }
      };

      updateModal();
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      lockBodyScroll();
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll();
    }

    function updateModal() {
      if (!modal) return;

      const track = modal.querySelector('.modal-track');
      if (!track) return;

      track.style.transform = `translateX(-${modalIndex * 100}%)`;

      modal.querySelectorAll('.modal-dots span')
        .forEach((d, i) => d.classList.toggle('is-active', i === modalIndex));

      modal.querySelectorAll('.modal-photo .point')
        .forEach((p, i) => p.classList.toggle('is-active', i === modalIndex));
    }

    if (nextBtn) nextBtn.addEventListener('click', () => showLook(lookIndex + 1));
    if (prevBtn) prevBtn.addEventListener('click', () => showLook(lookIndex - 1));

    looks.forEach((lookEl) => {
      const points = [...lookEl.querySelectorAll('.point')];
      const dots   = [...lookEl.querySelectorAll('.dots span')];
      const spBtn  = lookEl.querySelector('.common_btn.pc_none a');

      resetLookProducts(lookEl);

      points.forEach((p, i) => {
        p.addEventListener('click', () => {
          if (window.innerWidth <= 768 && modal) {
            openModal(lookEl, i);
          } else {
            showProduct(lookEl, i);
          }
        });
      });

      dots.forEach((d, i) => {
        d.addEventListener('click', () => showProduct(lookEl, i));
      });

      if (spBtn) {
        spBtn.addEventListener('click', (e) => {
          if (window.innerWidth <= 768 && modal) {
            e.preventDefault();
            openModal(lookEl, 0);
          }
        });
      }
    });

    if (modal) {
      modal.addEventListener('click', (e) => {
        if (e.target.closest('.modal-link')) return;

        const box = modal.querySelector('.modal-box');
        const close = e.target.closest('.modal-close');

        if (close || (box && !box.contains(e.target))) {
          closeModal();
        }
      });
    }

    updateScale();
    window.addEventListener('resize', updateScale);

    document.addEventListener('shopify:block:select', function(e) {
      const blockId = e.detail && e.detail.blockId;
      if (!blockId) return;

      const targetLook = area.querySelector(`.look[data-block-id="${blockId}"]`);
      if (!targetLook) return;

      activateLookByBlockId(blockId);
    });

    document.addEventListener('shopify:block:deselect', function(e) {
      if (!e.detail || !e.detail.blockId) return;

      const targetLook = area.querySelector(`.look[data-block-id="${e.detail.blockId}"]`);
      if (!targetLook) return;

      showLook(0);
      if (looks[0]) resetLookProducts(looks[0]);
    });
  }

  function bootLookbooks(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-lookbook]').forEach(initLookbook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      bootLookbooks(document);
    });
  } else {
    bootLookbooks(document);
  }

  document.addEventListener('shopify:section:load', function(e) {
    bootLookbooks(e.target);
  });
})();


(function(){
  function initColorThumbSwipers(scope){
    if (!window.Swiper) return;

    const root = scope || document;
    const els = root.querySelectorAll('.js-colorthumb-swiper');

    els.forEach(function(el){
      if (el.classList.contains('is-thumb-initialized')) return;

      const sw = new Swiper(el, {
        nested: true,
        slidesPerView: 'auto',
        spaceBetween: 4,

        freeMode: { enabled: true, momentum: true },
        grabCursor: true,
        threshold: 6,
        watchOverflow: true,

        // クリック挙動はあなたの「切替JS」で制御するので邪魔しない
        preventClicks: false,
        preventClicksPropagation: false,
        touchStartPreventDefault: false,

        on: {
          init(swiper){
            // ★これが大事：初期描画直後に計算を確定させる
            requestAnimationFrame(function(){
              swiper.update();
            });
          }
        }
      });

      el.classList.add('is-thumb-initialized');
    });
  }

  function boot(){
    initColorThumbSwipers(document);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // 画像読み込み後にレイアウトが変わる環境対策
  window.addEventListener('load', function(){
    initColorThumbSwipers(document);
    document.querySelectorAll('.js-colorthumb-swiper').forEach(function(el){
      if (el.swiper) el.swiper.update();
    });
  });

  // Shopifyのセクション再描画対策（テーマエディタ等）
  document.addEventListener('shopify:section:load', function(e){
    initColorThumbSwipers(e.target);
  });
})();
